import { getBonakirNotifications } from "../services/memberService";
import { bonakirNotifications, MemberProps } from "../typings/member";
import { Dispatch } from "redux";
import { type } from "os";

//Action Types
export const SET_USER_DATA = "setUserData";
export const RESET_USER_DATA = "resetUserData";
export const RESET_USER_MOOD = "RESET_USER_MOOD";
export const SET_UNREAD_MESSAGE_COUNT = "setUnreadMessageCount";
export const SET_BONAKIR_NOTIFICATIONS = "SET_BONAKIR_NOTIFICATIONS";

//Action creators
export const setUserData = (data: Partial<MemberProps>) => ({
  type: SET_USER_DATA,
  data,
});

export const setUnreadMessageCount = (data: number) => ({
  type: SET_UNREAD_MESSAGE_COUNT,
  data,
});

export const resetUserData = () => ({
  type: RESET_USER_DATA,
});

export const resetUserMood = (data: any) => ({
  type: RESET_USER_MOOD,
  data,
});

export const setBonakirNotifications =
  (memberCode: number) => async (dispatch: Dispatch) => {
    try {
      const { data } = await getBonakirNotifications(memberCode);
      dispatch({ type: SET_BONAKIR_NOTIFICATIONS, payload: data });
    } catch (err) {
      console.log(err);
    }
  };

const initialState: MemberProps = {
  memberCode: 0,
  age: 0,
  email: "",
  nickName: "",
  memberName: "",
  profilePicture: null,
  moodImage: null,
  moodText: null,
  profileSentence: null,
  accountHasInitialized: false,
  shouldGetAccountsCompletionQuestions: false,
  mediaHasVerified: null,
  mediaRequierVerification: null,
  showMeAsOffline: null,
  sentNotificationToMail: null,
  sentNotificationToPhone: null,
  emailIsVerified: false,
  hasBeenAuthenticatedByPhone: false,
  beedToBeAuthenticatedByPhone: false,
  unreadMessageCount: 0,
  profileIsVerified: false,
  profileRequierdVerification: false,
  dateOfBirth: "",
  bonakirNotifications: {
    newDoubleMatchesCount: 0,
    newSentToMeCount: 0,
    newWatchCount: 0,
  },
  shouldOpenSelectMood: false,
  isFreezedAccount: false,
  city: "",
  genderId: 0,
  isPremium: false,
  subscriptionExpiryDate: "",
  subscriptionPlanId: null,
  height: 0,
  isMemberPremiumFromStore: false,
  isMemberPremiumFromWeb: false,
  isPremium_Renewing: false,
  recurringPaymentUid: "",
  subscriptionPriceWeb: null,
};

//Reducer

export default function reducer(state = initialState, action: any) {
  switch (action.type) {
    case SET_USER_DATA:
      return { ...state, ...action.data };
    case RESET_USER_DATA:
      return { ...initialState };
    case RESET_USER_MOOD:
      return { ...state, ...action.data };
    case SET_UNREAD_MESSAGE_COUNT:
      return { ...state, unreadMessageCount: action.data };
    case SET_BONAKIR_NOTIFICATIONS:
      return { ...state, bonakirNotifications: action.payload };
    default:
      return state;
  }
}
